import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  regularizations: [],
  loading: false,
  error: null,
  pagination: {
    total_records: 0,
    current_page: 1,
    per_page: 10,
    total_pages: 1,
  },
  actionLoading: false,
};

const regularizationSlice = createSlice({
  name: "regularization",
  initialState,
  reducers: {
    getRegularizationsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    getRegularizationsSuccess: (state, action) => {
      state.loading = false;
      state.regularizations = action.payload.data;
      state.pagination = action.payload.pagination || state.pagination;
    },
    getRegularizationsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    updateRegularizationStatus: (state, action) => {
      const { id, status, rejection_reason, approved_by_name } = action.payload;
      const index = state.regularizations.findIndex((item) => item.id === id);
      if (index !== -1) {
        state.regularizations[index].status = status;
        if (rejection_reason) {
          state.regularizations[index].rejection_reason = rejection_reason;
        }
        if (approved_by_name) {
          state.regularizations[index].approved_by_name = approved_by_name;
        }
        state.regularizations[index].updated_at = new Date().toISOString();
      }
    },
    actionLoadingStart: (state) => {
      state.actionLoading = true;
    },
    actionLoadingEnd: (state) => {
      state.actionLoading = false;
    },
  },
});

export const {
  getRegularizationsStart,
  getRegularizationsSuccess,
  getRegularizationsFailure,
  updateRegularizationStatus,
  actionLoadingStart,
  actionLoadingEnd,
} = regularizationSlice.actions;

export default regularizationSlice.reducer;
